import { useCallback, useState } from 'react';
import { Keyboard } from 'react-native';
import { useLocalSearchParams } from 'expo-router';
import { useDebouncedValue } from '@/hooks/use-debounced-value';

export type SearchTab = 'places' | 'people' | 'menu-items';

export function useSearchState() {
  const { query: initialQuery } = useLocalSearchParams<{ query?: string }>();
  const [searchQuery, setSearchQuery] = useState(initialQuery || '');
  const [activeTab, setActiveTab] = useState<SearchTab>('places');
  const debouncedQuery = useDebouncedValue(searchQuery, 300);

  const handleSearchChange = useCallback((text: string) => {
    setSearchQuery(text);
  }, []);

  const handleSearchSubmit = useCallback(() => {
    Keyboard.dismiss();
  }, []);

  return {
    searchQuery,
    activeTab,
    debouncedQuery,
    setActiveTab,
    handleSearchChange,
    handleSearchSubmit,
  };
}
